import {Locales} from '@netx/core-next/locales/utils/Locales';
import {DownloadRequestReviewStatus, DownloadRequestField} from './schema';

export const DownloadRequestsLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.downloadRequests'),
	UNKNOWN: i18n('i18n.unknown'),
}));

export const DownloadRequestColumnLabel = Locales<
	Partial<Record<keyof typeof DownloadRequestField, string>>
>((i18n) => ({
	[DownloadRequestField.requester]: i18n('i18n.requestedBy'),
	[DownloadRequestField.requestDate]: i18n('i18n.date'),
	[DownloadRequestField.approvalCount]: i18n('i18n.assets'),
	[DownloadRequestField.reviewStatus]: i18n('i18n.status'),
	[DownloadRequestField.portalContext]: i18n('i18n.source'),
}));

export const DownloadRequestsSubTitle = Locales((i18n) => ({
	ITEMS_APPROVED: (count: number) => i18n('i18n.nItemsApproved', {count}),
	TOTAL: (count: number) => i18n('i18n.nItems', {count}),
}));

export const DownloadRequestsTitle = Locales((i18n) => ({
	DOWNLOAD_REQUEST: i18n('i18n.downloadRequest'),
	DOWNLOAD_REQUESTS: i18n('i18n.downloadRequests'),
	JUSTIFICATION: i18n('i18n.justification'),
	FILES: i18n('i18n.files'),
}));

export const DownloadRequestMessage = Locales((i18n) => ({
	ERROR: i18n('i18n.error'),
	NO_RECORDS: i18n('i18n.noRecords'),
	NO_MATCHING_RECORDS: i18n('i18n.noMatches'),
}));

export const DownloadRequestApprovalColumnLabel = Locales((i18n) => ({
	assetName: i18n('i18n.name'),
	assetFileType: i18n('i18n.fileType'),
}));

export const DownloadRequestReviewStatusLabel = Locales<
	Record<
		(typeof DownloadRequestReviewStatus)[keyof typeof DownloadRequestReviewStatus],
		string
	>
>((i18n) => ({
	[DownloadRequestReviewStatus.COMPLETED]: i18n('i18n.completed'),
	[DownloadRequestReviewStatus.NO_APPROVAL_REQUIRED]: i18n(
		'i18n.noApprovalRequired',
	),
	[DownloadRequestReviewStatus.PENDING]: i18n('i18n.pending'),
	[DownloadRequestReviewStatus.JUSTIFIED]: i18n('i18n.justified'),
}));

export const DownloadRequestActionLabel = Locales((i18n) => ({
	ADD_TO_CART: i18n('i18n.selectAll'),
	APPROVE: i18n('i18n.approve'),
	APPROVE_ALL: i18n('i18n.approveAll'),
	DENY_ALL: i18n('i18n.denyAll'),
	EXPORT: i18n('i18n.export'),
	LIST: i18n('i18n.downloadRequests'),
	VIEW: i18n('i18n.viewAssets'),
	CONTINUE: i18n('i18n.continue'),
	DONE: i18n('i18n.done'),
}));
